export default "__VITE_ASSET__DfhBlxfm__"